import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  UntypedFormBuilder,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  LearmoModalRef,
  LearmoModalService,
} from '../../../../shared/services/learmo-modal.service';
import { ActiveToast, ToastrService } from 'ngx-toastr';

import {
  MessengerThread,
  MessengerUserRoleEnum,
} from '../../../../models/owner-dashboard';

export enum InvitationCurrentStepEnum {
  input = 'input',
  result = 'result',
}
@Component({
  selector: 'app-thread-users-list-popup',
  templateUrl: './thread-users-list-popup.component.html',
  styleUrls: ['./thread-users-list-popup.component.css'],
})
export class ThreadUsersPopupComponent implements OnInit {
  messengerUserRoleEnum = MessengerUserRoleEnum;
  @Input() thread: MessengerThread;

  // Report Toaster
  reportToaster: ActiveToast<any>;

  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild('modalFooter') modalFooter: TemplateRef<any>;
  @Input() modalRef: LearmoModalRef;
  constructor(
    private modalService: LearmoModalService,
    private route: Router,
    private fb: UntypedFormBuilder,
    private toastr: ToastrService
  ) {}

  async ngOnInit() {}

  onOpenModal() {}

  closeModal() {
    this.modalRef.dismiss();
  }

  // Modal Open
  async open(content?) {
    this.onOpenModal();
    this.modalRef = this.modalService.open(this.modalContent, {
      title: 'Chat Users List',
      icon: 'users',
      footer: this.modalFooter,
      premium: true,
      size: 'lg',
    });
  }
}
